import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getOtherCoverage(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            //if (domainData && domainData.t && domainData.aai) {
            const response = yield call(hpServicesApi.OtherCoverageApi.getOtherCoverage, domainData.t, memberId); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.OtherCoverage.GetOtherCoverage.Get", start, null);
            yield put({ type: types.HP_GET_OTHER_COVERAGE_SUCCESS, otherCoverage: response, isFetching: false });
            //}
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.OtherCoverage.GetOtherCoverage.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_OTHER_COVERAGE_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.OtherCoverage.GetOtherCoverage.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}


export function* updateOtherCoverage(params) {

    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            //if (domainData && domainData.t && domainData.aai) {
            const response = yield call(hpServicesApi.OtherCoverageApi.updateOtherCoverage, domainData.t, memberId, params.subName, params.subBirthDate, params.subGender, params.rltpToSub, params.policyType, params.mbi, params.coverageType,
                params.planName, params.altPolicyNum, params.groupName, params.groupNumber, params.priority, params.isCourtOrdered, params.isRetiree, params.companyName, params.address, params.address2, params.city, params.state, params.zip, params.area, params.phoneNumber, params.extension, params.startDate, params.policyId); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.OtherCoverage.UpdateOtherCoverage.Post", start, null);
            yield put({ type: types.HP_UPDATE_OTHER_COVERAGE_SUCCESS, otherCoverageRequestNumber: response, isFetching: false });
            //}
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.OtherCoverage.UpdateOtherCoverage.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_UPDATE_OTHER_COVERAGE_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.OtherCoverage.UpdateOtherCoverage.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}